import { Component } from '@angular/core';
import { MAPSConferenceRegistrationEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';

@RegisterClass(BaseFormComponent, 'Conference Registrations') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-mapsconferenceregistration-form',
    templateUrl: './mapsconferenceregistration.form.component.html'
})
export class MAPSConferenceRegistrationFormComponent extends BaseFormComponent {
    public record!: MAPSConferenceRegistrationEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'details', sectionName: 'Details', isExpanded: true }
        ]);
    }
}

